import { GridCellProps } from "@progress/kendo-react-grid";
import { TimePicker, TimePickerChangeEvent } from "@progress/kendo-react-dateinputs";
import { getDateFromString } from "./GetDateFromString";
import { getStringFromDate } from "./GetStringFromDate";
import { getStringWithZeroPadFromDate } from "./GetStringWithZeroPadFromDate";
import { ReadOnlyProps } from "../../../ReadOnlyProps";

export function TimePickerCell({ isReadOnly, ...props }: GridCellProps & ReadOnlyProps) {
  const { dataItem, field, onChange } = props;

  const myField = field || "";
  const dataValue: string = dataItem[myField] === null ? "" : dataItem[myField];
  const dateValue = getDateFromString(dataValue);

  const handleChange = (e: TimePickerChangeEvent) => {
    if (!onChange) {
      return;
    }

    const time = e.target.value;
    const value = getStringFromDate(time);
    onChange({
      dataIndex: 0,
      dataItem,
      field,
      syntheticEvent: e.syntheticEvent,
      value,
    });
  };

  const steps = {
    hour: 1,
    minute: 30,
    second: 0,
  };

  return (
    <td>
      {dataItem.inEdit && !isReadOnly ? (
        <TimePicker
          format="HH:mm"
          value={dateValue}
          onChange={handleChange}
          placeholder="HH:mm"
          steps={steps}
        />
      ) : (
        getStringWithZeroPadFromDate(dateValue)
      )}
    </td>
  );
}
